/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wf_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word Frequency Counter`)
};

const es_wf_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de Frecuencia de Palabras`)
};

const de_wf_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wortfrequenzzähler`)
};

const nl_wf_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woordfrequentieteller`)
};

const fr_wf_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compteur de fréquence des mots`)
};

const it_wf_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatore di frequenza delle parole`)
};

const pt_br2_wf_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de Frequência de Palavras`)
};

const pt_wf_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de Frequência de Palavras`)
};

const ja_wf_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語頻度カウンター`)
};

const zh_wf_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`词频统计工具`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wf_nav_main = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wf_nav_main(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wf_nav_main", locale)
	if (locale === "en") return en_wf_nav_main(inputs)
	if (locale === "es") return es_wf_nav_main(inputs)
	if (locale === "de") return de_wf_nav_main(inputs)
	if (locale === "nl") return nl_wf_nav_main(inputs)
	if (locale === "fr") return fr_wf_nav_main(inputs)
	if (locale === "it") return it_wf_nav_main(inputs)
	if (locale === "pt-BR") return pt_br2_wf_nav_main(inputs)
	if (locale === "pt") return pt_wf_nav_main(inputs)
	if (locale === "ja") return ja_wf_nav_main(inputs)
	return zh_wf_nav_main(inputs)
};